<template>
  <div v-if="data">
    <div class="title base">
      <p id="name">{{ $t("商品") }}</p>
      <p id="time">{{ $t("下单时间") }}</p>
      <p id="to">{{ $t("收货人") }}</p>
      <p id="count">{{ $t("合计") }}</p>
      <p id="stat">{{ $t("状态") }}</p>
      <p id="operation">{{ $t("操作") }}</p>
    </div>
    <div v-if="dataLength">
      <div v-for="tr in data.items" :key="tr.id" class="border mb-4">
        <div class="col-span-6 border-b p-4 flex flex-nowrap">
          <span class="">{{ $t("订单号") }}：{{ tr.ordernum }}</span>
          <!-- <span class="ml-auto"
            ><FlightBoard class="inline-block" :item="tr.flight"></FlightBoard
          ></span> -->
        </div>
        <div class="base pstyle">
          <div class="h-full border-r w-full divide-y-1 justify-self-center">
            <div v-for="item in tr.items" :key="item.id" class="flex p-2">
              <img :src="$firstImage(item.images, 'small')" alt="" class="img w-32 h-32 p-2" :onerror="defaultUrl" />
              <div class="flex justify-between w-70 pt-2">
                <p class="font-semibold">{{ item.name }}</p>
                <p class="text-right pr-5">
                  <span class="block font-semibold">{{ $p(item.price) }}</span>
                  <span class="block text-gray-400">×{{ item.quantity }}</span>
                </p>
              </div>
            </div>
          </div>
          <p class="">{{ tr.created.date }}</p>
          <p>{{ tr.receiver }}</p>
          <p class="text-red-500">{{ $p(tr.finalprice) }}</p>
          <p class="text-green-500 flex-wrap">
            <span>
              <span class="block">{{ tr.status_text }}</span>
              <span class="block">
                <el-link type="info" :underline="false" class="block">
                  <router-link :to="{ name: 'SupOrderDetail', params: { id: tr.id, oid: tr.id } }">{{ $t("订单详情")
                  }}</router-link>
                </el-link>
              </span>
            </span>
          </p>
          <p>
            <span v-if="tr.status === -1">
              <!-- <el-link type="danger" :underline="false" class="block" @click="removeOrder(tr.id)">
                {{ $t(" 删除") }}
              </el-link> -->
            </span>
            <span v-else-if="tr.status === 0">
              <!-- <el-button
                class="take"
                @click="goPay(tr.id)"
                type="warning"
                size="small"
                round
              >
                {{ $t("去付款") }}
              </el-button> -->
              <el-button type="warning" @click="recMoney(tr.ordernum)" round size="small" class="take">
                {{ $t("确认收款") }}
              </el-button>
              <el-link type="danger" :underline="false" class="block" @click="cancelOrder(tr.id)">
                {{ $t("取消订单") }}
              </el-link>
            </span>
            <span v-else-if="tr.status === 100">
              <!-- <el-button
                class="take"
                @click="finishOrder(tr.id)"
                round
                type="warning"
                size="small"
              >
                {{ $t("确认收货") }}
              </el-button> -->
            </span>
            <span v-else-if="tr.status === 10">
              <el-button type="warning" @click="sendGoods(tr.id)" round size="small" class="take">
                {{ $t("发货 ") }}
              </el-button>
              <!-- <span @click="next(tr)">next</span> -->
            </span>
            <span v-else-if="tr.status === 1000">
              <!-- <el-button
                type="primary"
                round
                size="small"
                class="comment"
                @click="comment(tr.id)"
                v-if="!tr.commenttime"
              >
                {{ $t("评价") }}
              </el-button> -->
              <!-- <el-link type="info" :underline="false" class="block" v-else>
                {{ $t("已评价") }}
              </el-link> -->
              <!-- <el-link type="danger" :underline="false" class="block" @click="removeOrder(tr.id)">
                {{ $t("删除") }}
              </el-link> -->
            </span>
          </p>
        </div>
      </div>
      <div id="foot" class="mt-6" v-if="data.total">
        <el-pagination background layout="prev, pager, next" :total="Number(dataLength)" :page-size="5"
          @current-change="handleCurrentChange" :current-page.sync="currentPage"
          :hide-on-single-page="true"></el-pagination>
      </div>
    </div>
    <div v-else class="mt-60">
      <img :src="require(`@/assets/image/暂无订单.png`)" class="mx-auto" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-dom";
import { ref, watchEffect, onUpdated } from "@vue/composition-api";
// import FlightBoard from "./flightBoard.vue";

export default defineComponent({
  components: {},
  props: { data: Object, page: Number },
  setup(props, ctx) {
    const currentPage = ref();
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';

    watchEffect(() => {
      currentPage.value = props.page;
    });

    const dataLength = ref();
    onUpdated(() => {
      dataLength.value = props.data?.items?.length ? props.data.total : 0;
    });
    const handleCurrentChange = () => {
      document.documentElement.scrollTop = 0;
      ctx.emit("updataPage", currentPage.value);
    };
    //删除订单
    const removeOrder = async (id) => {
      const res = await ctx.root.$query(ctx.root.$t("您确定要删除订单?"));
      if (res) {
        ctx.emit("remove", id, "delete");
      }
    };
    //取消订单
    const cancelOrder = async (id) => {
      const res = await ctx.root.$query(ctx.root.$t("您确定要取消订单?"));
      if (res) {
        ctx.emit("cancel", id, "cancel");
      }
    };
    const next = async (e) => {
      const res = await ctx.root.$callapi("user/doForOrderAction", {
        ids: [e.id],
        action: "sent",
      });
    };
    //去付款
    const goPay = (id) => {
      ctx.root.$router.push({
        name: "OrderDetail",
        params: { id },
        query: { pay: true },
      });
    };
    // 确认收款
    const payImage = {
      image: ''
    }
    const recMoney = async (ordernum) => {
      const imgRes = await ctx.root.$chooseImages();

      if (!imgRes) return;
      payImage.image = imgRes.path
      await ctx.root.$autoUploads(payImage, "image");
      // personData.icon = res.path;
      let query = await ctx.root.$query(ctx.root.$t('您确定已收到买家的花款'))
      if (!query) return
      ctx.root.$doing()
      let res = await ctx.root.$callapi('sup/confirmReceipt', {
        onum: ordernum,
        pay_images: payImage.image
      })
      ctx.root.$done()
      if (res.code == 0 && res.data) {
        ctx.emit('reload')
        ctx.root.$toast(ctx.root.$t('操作成功'),'success')
      }
    }
    //发货
    const sendGoods = async (id) => {
      // console.log("sendgoods")
      const res = await ctx.root.$query(ctx.root.$t("您确定发货?"));
      if (res) {
        // console.log("sendgoods")
        ctx.emit("send", id, "send");
      }
    }
    //确认收货
    const finishOrder = async (id) => {
      const res = await ctx.root.$query(ctx.root.$t("您确定已收到货?"));
      if (res) {
        ctx.emit("finish", id, "finish");
      }
    };
    //去评价
    const comment = (id) => {
      ctx.root.$router.push({
        name: "evaluation",
        params: { id },
      });
    };

    return {
      handleCurrentChange,
      currentPage,
      dataLength,
      removeOrder,
      cancelOrder,
      next,
      finishOrder,
      comment,
      defaultUrl,
      goPay,
      sendGoods,
      recMoney
    };
  },
});
</script>

<style scoped lang="scss">.base {
  display: grid;
  grid-template-columns: 3fr repeat(5, 1fr);
}
.pstyle>p {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  border-right-width: 1px;
  height: 100%;
}
.pstyle>p:last-child {
  border-right-width: 0px;
}
.title {
  border-width: 1px;
  margin-bottom: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  background-color: #f4f4f5;
}
.take {
  min-width: 5.6rem;
  font-size: 0.8rem;
  background: linear-gradient(-97.27deg, #ff4a4a 0%, #ff8a00 100%);
}
.take:hover {
  background: #ff8a00;
}
.comment {
  min-width: 5.6rem;
  font-size: 00.8rem;
  background: linear-gradient(-97.27deg, #6ed490 0%, #34b66b 100%);
  border: 0;
}
.comment:hover {
  background: #6ed490;
}</style>
